// country-flags.ts
export const COUNTRY_FLAG_MAP: Record<string, string> = {
  // A
  "afghanistan": "af",
  "aland islands": "ax",
  "aland": "ax",
  "albania": "al",
  "algeria": "dz",
  "american samoa": "as",
  "andorra": "ad",
  "angola": "ao",
  "anguilla": "ai",
  "antarctica": "aq",
  "antigua and barbuda": "ag",
  "argentina": "ar",
  "armenia": "am",
  "aruba": "aw",
  "australia": "au",
  "austria": "at",
  "azerbaijan": "az",

  // B
  "bahamas": "bs",
  "bahrain": "bh",
  "bangladesh": "bd",
  "barbados": "bb",
  "belarus": "by",
  "belgium": "be",
  "belize": "bz",
  "benin": "bj",
  "bermuda": "bm",
  "bhutan": "bt",
  "bolivia": "bo",
  "bolivia (plurinational state of)": "bo",
  "bosnia and herzegovina": "ba",
  "bosnia": "ba",
  "botswana": "bw",
  "brazil": "br",
  "british indian ocean territory": "io",
  "brunei": "bn",
  "brunei darussalam": "bn",
  "bulgaria": "bg",
  "burkina faso": "bf",
  "burundi": "bi",

  // C
  "cabo verde": "cv",
  "cape verde": "cv",
  "cambodia": "kh",
  "cameroon": "cm",
  "canada": "ca",
  "cayman islands": "ky",
  "central african republic": "cf",
  "chad": "td",
  "chile": "cl",
  "china": "cn",
  "people's republic of china": "cn",
  "prc": "cn",
  "christmas island": "cx",
  "cocos islands": "cc",
  "cocos (keeling) islands": "cc",
  "colombia": "co",
  "comoros": "km",
  "congo": "cg",
  "republic of the congo": "cg",
  "congo, democratic republic of the": "cd",
  "democratic republic of the congo": "cd",
  "congo drc": "cd",
  "cook islands": "ck",
  "costa rica": "cr",
  "cote d'ivoire": "ci",
  "ivory coast": "ci",
  "croatia": "hr",
  "cuba": "cu",
  "curacao": "cw",
  "cyprus": "cy",
  "czechia": "cz",
  "czech republic": "cz",

  // D
  "denmark": "dk",
  "djibouti": "dj",
  "dominica": "dm",
  "dominican republic": "do",

  // E
  "ecuador": "ec",
  "egypt": "eg",
  "el salvador": "sv",
  "equatorial guinea": "gq",
  "eritrea": "er",
  "estonia": "ee",
  "eswatini": "sz",
  "swaziland": "sz",
  "ethiopia": "et",

  // F
  "falkland islands": "fk",
  "falkland islands (malvinas)": "fk",
  "faroe islands": "fo",
  "fiji": "fj",
  "finland": "fi",
  "france": "fr",
  "french guiana": "gf",
  "french polynesia": "pf",
  "french southern territories": "tf",

  // G
  "gabon": "ga",
  "gambia": "gm",
  "georgia": "ge",
  "germany": "de",
  "german federation": "de",
  "ghana": "gh",
  "gibraltar": "gi",
  "greece": "gr",
  "greenland": "gl",
  "grenada": "gd",
  "guadeloupe": "gp",
  "guam": "gu",
  "guatemala": "gt",
  "guernsey": "gg",
  "guinea": "gn",
  "guinea-bissau": "gw",
  "guyana": "gy",

  // H
  "haiti": "ht",
  "heard island and mcdonald islands": "hm",
  "honduras": "hn",
  "hong kong": "hk",
  "hong kong sar": "hk",

  // I
  "iceland": "is",
  "india": "in",
  "indonesia": "id",
  "iran": "ir",
  "iran (islamic republic of)": "ir",
  "iraq": "iq",
  "ireland": "ie",
  "isle of man": "im",
  "israel": "il",
  "italy": "it",

  // J
  "jamaica": "jm",
  "japan": "jp",
  "jersey": "je",
  "jordan": "jo",

  // K
  "kazakhstan": "kz",
  "kenya": "ke",
  "kiribati": "ki",
  "north korea": "kp",
  "democratic people's republic of korea": "kp",
  "dprk": "kp",
  "south korea": "kr",
  "republic of korea": "kr",
  "korea, republic of": "kr",
  "kuwait": "kw",
  "kyrgyzstan": "kg",

  // L
  "laos": "la",
  "lao people's democratic republic": "la",
  "latvia": "lv",
  "lebanon": "lb",
  "lesotho": "ls",
  "liberia": "lr",
  "libya": "ly",
  "liechtenstein": "li",
  "lithuania": "lt",
  "luxembourg": "lu",

  // M
  "macao": "mo",
  "macau": "mo",
  "macedonia, north": "mk",
  "north macedonia": "mk",
  "madagascar": "mg",
  "malawi": "mw",
  "malaysia": "my",
  "maldives": "mv",
  "mali": "ml",
  "malta": "mt",
  "marshall islands": "mh",
  "martinique": "mq",
  "mauritania": "mr",
  "mauritius": "mu",
  "mayotte": "yt",
  "mexico": "mx",
  "micronesia": "fm",
  "micronesia, federated states of": "fm",
  "moldova": "md",
  "republic of moldova": "md",
  "monaco": "mc",
  "mongolia": "mn",
  "montenegro": "me",
  "montserrat": "ms",
  "morocco": "ma",
  "mozambique": "mz",
  "myanmar": "mm",
  "burma": "mm",

  // N
  "namibia": "na",
  "nauru": "nr",
  "nepal": "np",
  "netherlands": "nl",
  "holland": "nl",
  "netherlands kingdom of the": "nl",
  "new caledonia": "nc",
  "new zealand": "nz",
  "nicaragua": "ni",
  "niger": "ne",
  "nigeria": "ng",
  "niue": "nu",
  "norfolk island": "nf",
  "northern mariana islands": "mp",
  "norway": "no",

  // O
  "oman": "om",

  // P
  "pakistan": "pk",
  "palau": "pw",
  "palestine": "ps",
  "state of palestine": "ps",
  "panama": "pa",
  "papua new guinea": "pg",
  "paraguay": "py",
  "peru": "pe",
  "philippines": "ph",
  "pitcairn": "pn",
  "poland": "pl",
  "portugal": "pt",
  "puerto rico": "pr",

  // Q
  "qatar": "qa",

  // R
  "reunion": "re",
  "romania": "ro",
  "russia": "ru",
  "russian federation": "ru",
  "rwanda": "rw",

  // S
  "saint barthelemy": "bl",
  "saint barthélemy": "bl",
  "saint helena": "sh",
  "saint helena, ascension and tristan da cunha": "sh",
  "saint kitts and nevis": "kn",
  "saint lucia": "lc",
  "saint martin": "mf",
  "saint martin (french part)": "mf",
  "saint pierre and miquelon": "pm",
  "saint vincent and the grenadines": "vc",
  "samoa": "ws",
  "san marino": "sm",
  "sao tome and principe": "st",
  "sao tome & principe": "st",
  "saudi arabia": "sa",
  "kingdom of saudi arabia": "sa",
  "senegal": "sn",
  "serbia": "rs",
  "seychelles": "sc",
  "sierra leone": "sl",
  "singapore": "sg",
  "sint maarten": "sx",
  "slovakia": "sk",
  "slovenia": "si",
  "solomon islands": "sb",
  "somalia": "so",
  "south africa": "za",
  "south sudan": "ss",
  "spain": "es",
  "sri lanka": "lk",
  "sudan": "sd",
  "suriname": "sr",
  "svalbard and jan mayen": "sj",
  "sweden": "se",
  "switzerland": "ch",
  "syrian arab republic": "sy",
  "syria": "sy",

  // T
  "taiwan": "tw",
  "taiwan, province of china": "tw",
  "tajikistan": "tj",
  "tanzania": "tz",
  "united republic of tanzania": "tz",
  "thailand": "th",
  "timor-leste": "tl",
  "east timor": "tl",
  "togo": "tg",
  "tokelau": "tk",
  "tonga": "to",
  "trinidad and tobago": "tt",
  "tunisia": "tn",
  "turkey": "tr",
  "türkiye": "tr",
  "turkmenistan": "tm",
  "turks and caicos islands": "tc",
  "tuvalu": "tv",

  // U
  "uganda": "ug",
  "ukraine": "ua",
  "united arab emirates": "ae",
  "uae": "ae",
  "united kingdom": "gb",
  "uk": "gb",
  "u.k.": "gb",
  "great britain": "gb",
  "britain": "gb",
  "england": "gb",
  "scotland": "gb",
  "wales": "gb",
  "northern ireland": "gb",
  "united states": "us",
  "united states of america": "us",
  "usa": "us",
  "u.s.a": "us",
  "u.s.": "us",
  "us": "us",
  "america": "us",
  "uruguay": "uy",
  "uzbekistan": "uz",

  // V
  "vanuatu": "vu",
  "vatican city": "va",
  "holy see": "va",
  "vatican": "va",
  "venezuela": "ve",
  "venezuela (bolivarian republic of)": "ve",
  "vietnam": "vn",
  "viet nam": "vn",
  "virgin islands, british": "vg",
  "british virgin islands": "vg",
  "virgin islands, u.s.": "vi",
  "u.s. virgin islands": "vi",

  // W
  "wallis and futuna": "wf",
  "western sahara": "eh",

  // Y
  "yemen": "ye",

  // Z
  "zambia": "zm",
  "zimbabwe": "zw",

  //fallback
  "world": "un", 
};
